import { render, staticRenderFns } from "./OnboardingContribution.vue?vue&type=template&id=4fbe57b4"
import script from "./OnboardingContribution.vue?vue&type=script&lang=ts"
export * from "./OnboardingContribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports